<template>

    <div class="admin-support-plan-annotations"
         v-if="config.supportPlan">

        <b-form-input placeholder="Search" class="mb-4"
                      v-model="annotationSearch">
        </b-form-input>

        <draggable class="dragArea"
                   v-model="config.supportPlan.annotations">

            <b-row class="my-2"
                   v-for="annotation in filteredAnnotations"
                   :key="annotation.id">
                <b-col>
                    <b-card no-body class="mb-3">
                        <b-card-header>

                            <b-row>
                                <b-col cols="1">
                                    <open-icon name="resize-height"
                                               class="drag-handle"></open-icon>
                                </b-col>
                                <b-col cols="10">
                                    <b-form-textarea class="card-header-input admin-support-plan-annotations__text-area"
                                            v-model="annotation.text"/>
                                </b-col>
                                <b-col cols="1">
                                    <b-btn variant="default" size="sm"
                                           @click="deleteAnnotation(annotation)">
                                        <open-icon
                                                name="delete"></open-icon>
                                    </b-btn>
                                </b-col>
                            </b-row>

                        </b-card-header>
                    </b-card>
                </b-col>
            </b-row>
        </draggable>

        <b-btn variant="success" size="sm" class="float-right mb-3"
               @click="addAnnotation()">
            Add Citation
        </b-btn>

        <div class="clearfix"></div>

    </div>

</template>

<script>

    import Vue from 'vue'
    import draggable from 'vuedraggable'

    export default Vue.extend({
        name: 'AdminSupportPlanAnnotations',
        components: {
            draggable
        },
        data() {
            return {
                annotationSearch: null,
            }
        },
        computed: {
            config() {
                return this.$store.state.config
            },
            filteredAnnotations() {
                return _.filter(this.config.supportPlan.annotations, (a) => {
                    return !this.annotationSearch ||
                        a.text.toLowerCase().indexOf(this.annotationSearch.toLowerCase()) != -1
                })
            }
        },
        methods: {
            addAnnotation() {
                this.annotationSearch = null
                const annotation = this.getNewAnnotation()
                const maxAnnotation = _.maxBy(this.config.supportPlan.annotations, (a) => a.id)
                annotation.id = maxAnnotation ? maxAnnotation.id + 1 : 1
                this.config.supportPlan.annotations.push(annotation)
            },
            deleteAnnotation(annotation) {
                if (confirm('Permanently delete this annotation? This will also remove the annotation from any Strategies that include it.')) {
                    this.config.supportPlan.annotations = _.without(this.config.supportPlan.annotations, annotation)

                    // remove from strategies
                    _.each(this.config.supportPlan.strategies, (strategy) => {
                        strategy.annotations = _.without(strategy.annotations, annotation.id)
                    })
                }
            },
            getNewAnnotation() {
                return {
                    text: 'New Annotation',
                }
            }
        },
    })
</script>

<style lang="scss">
    .admin-support-plan-annotations__text-area {
        width: 100%;
        min-height: 100px;
    }
</style>